export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-border bg-primary py-4 select-none"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-primary-foreground/90">
                <span className="px-8 text-lg font-bold tracking-wide whitespace-nowrap">{item}</span>
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-foreground/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
